import { useParams } from 'react-router-dom';
import _ from 'lodash';
import useQueryParams from 'v2/hooks/useQueryParams';

export interface useGetPageNumberProps {
  paramName?: string;
  onNotValidPageNumber?: (pageAssigned: number) => void;
  /** @default 'path' */
  from?: 'query' | 'path';
}

export default function useGetPageNumber({
  paramName = 'page',
  onNotValidPageNumber,
  from = 'path',
}: useGetPageNumberProps): number {
  const params = useParams<Record<string, string | undefined>>();
  const queryParams = useQueryParams();
  const page =
    from === 'query' ? queryParams.get(paramName) : params[paramName];
  const initialPage = 1;
  let currentPage = initialPage;
  if (page) {
    const numberPage = Number(page);
    if (!_.isNaN(numberPage) && numberPage !== 0) {
      currentPage = numberPage;
    } else {
      onNotValidPageNumber?.(initialPage);
    }
  }
  return currentPage;
}
